export const starColors = {
  NO_STAR: '',
  YELLOW: 'var(--fett-surface-warning-text)',
  RED: 'var(--fett-surface-error-text)',
  GREEN: 'var(--fett-scenario-success-text)',
  BLUE: '#3370FF',
  PURPLE: 'var(--fett-scenario-purple-text)',
};

export const hasStar = (color: string) =>
  ['YELLOW', 'RED', 'GREEN', 'BLUE', 'PURPLE'].includes(color);

/** 界面可过滤的星标 */
export const starUIFilterArr: Conversation.asteriskUIFilter[] = [
  'ALL',
  'YELLOW',
  'RED',
  'GREEN',
  'BLUE',
  'PURPLE',
];

/** 界面可操作的星标 */
export const starUIOps: Conversation.asteriskUIOps[] = [
  'NO_STAR',
  'YELLOW',
  'RED',
  'GREEN',
  'BLUE',
  'PURPLE',
];
